// const movies = document.querySelectorAll('.topMv__bg,.bgMovie__container')
const movies = document.querySelectorAll('.bgMovie__container')
movies.forEach((container) => {
  const video = container.querySelector('video')

  if (video) {
    video
      .play()
      .then(() => {
        // 省電力モードではないときの処理
        //alert("省電力モードではありません");
      })
      .catch((error) => {
        // 省電力モードのときの処理
        container.classList.add('no-movie')
      })
  } else {
    container.classList.add('no-movie')
  }
})

const topMovie = document.querySelector('.topMv__bg')
if (topMovie) {
  const video = topMovie.querySelector('video')

  if (video) {
    // ブレイクポイントを設定
    const mediaQuery = window.matchMedia('(min-width: 768px)')

    // 関数を定義
    function checkWindow(windowSize) {
      // ウィンドウサイズが768px以上か
      if (windowSize.matches) {
        // 768px以上の時（PCの処理）
        video.setAttribute('poster', tUrl + 'img/top/mv_image.png')
      } else {
        // 上記以外の時（SPの処理）
        video.setAttribute('poster', tUrl + 'img/top/mv_image_sp.png')
      }
    }

    // ロード時に判定
    checkWindow(mediaQuery)

    // ブレイクポイントが切り替わったら判定
    mediaQuery.addEventListener('change', checkWindow)

    // video.currentTime = 9.7

    video
      .play()
      .then(() => {
        // 省電力モードではないときの処理
        //alert("省電力モードではありません");
      })
      .catch((error) => {
        // 省電力モードのときの処理
        topMovie.classList.add('no-movie')
      })
  } else {
    topMovie.classList.add('no-movie')
  }
}
